export const faqData = [
    // --- AI Data Services FAQs ---
    {
        id: 1,
        question: 'What types of AI data collection services do you offer?',
        answer: 'We offer end-to-end data collection including image datasets, video recordings, speech and audio samples, text corpora, and survey data. Each project is custom-scoped to your AI or ML model requirements, with participant recruitment and quality assurance included.'
    },
    {
        id: 2,
        question: 'What annotation and labeling formats do you support?',
        answer: 'We support a wide range of annotation types including bounding box, polygon, semantic segmentation, instance segmentation, keypoint and landmark annotation, audio transcription, NLP labeling, sentiment classification, and 3D point cloud annotation. Final deliverables can be provided in formats compatible with most ML frameworks.'
    },
    {
        id: 3,
        question: 'How do you ensure dataset quality and accuracy?',
        answer: 'Every dataset goes through multiple quality control stages — manual review, validation checks, accuracy verification, duplicate detection, compliance assessment, and metadata verification. We maintain strict quality benchmarks and provide validation reports with each delivery.'
    },
    {
        id: 4,
        question: 'Can you recruit participants for specific demographics or languages?',
        answer: 'Yes. Our global recruitment network can source participants based on age, profession, language, accent, region, device usage, and other project-specific criteria. We support multilingual and multi-demographic data collection across dozens of countries.'
    },
    {
        id: 5,
        question: 'What industries do your AI data services support?',
        answer: 'Our data collection and annotation services support AI teams across computer vision, NLP, autonomous vehicles, healthcare and medical imaging, retail and e-commerce, agriculture, smart cities, and IoT. We tailor collection methodology to each industry\'s specific requirements.'
    },
    {
        id: 6,
        question: 'How is collected data handled and kept secure?',
        answer: 'We follow strict data handling and confidentiality practices throughout the collection, annotation, and delivery process. Data is handled in compliance with project-specific privacy requirements, and all contributors sign appropriate agreements before participation.'
    },
    {
        id: 7,
        question: 'Can you scale from a small pilot to a large enterprise dataset?',
        answer: 'Absolutely. We handle projects ranging from small pilot datasets to large-scale enterprise data collection. Our project management team ensures smooth scaling without compromising quality or timelines.'
    },

    // --- Digital Marketing FAQs ---
    {
        id: 8,
        question: 'What digital marketing services do you offer?',
        answer: 'We offer a full suite of digital marketing services including website development, SEO and content marketing, social media marketing (SMO), Google Ads and PPC, Meta Ads (Facebook and Instagram), and email and domain migration.'
    },
    {
        id: 9,
        question: 'How long does it take to see results from digital marketing?',
        answer: 'Most clients see initial improvements within 30–60 days, with significant results typically appearing within 3–6 months. Timeline varies based on your industry, competition, and specific goals.'
    },
    {
        id: 10,
        question: 'What is your pricing structure?',
        answer: 'Our pricing is customized based on your specific needs — whether that\'s an AI data collection project, an annotation pipeline, or a digital marketing campaign. Contact us for a personalized quote.'
    },
    {
        id: 11,
        question: 'Do you work with startups and small businesses?',
        answer: 'Yes. We work with businesses and research teams of all sizes — from early-stage startups building their first AI model to large enterprises running global marketing campaigns. We tailor our approach to fit your goals and budget.'
    }
];
